export interface ICartAccessoryType {
  name: string;
  code: string;
}

export interface ICartAccessory {
  type?: string;
  price?: number;
  isRemoved?: boolean;
}

// TODO: replace enum with service to fetch info from DB when experiment is over
// @martin.carrera
export const CartAccessory: {
  BASE_OR_SUPPORT: ICartAccessoryType;
  BLUETOOTH_SPEAKER: ICartAccessoryType;
  CABLE: ICartAccessoryType;
  CAMERA_ACCESSORY: ICartAccessoryType;
  CAR_CHARGER: ICartAccessoryType;
  CAR_SUPPORT: ICartAccessoryType;
  CHARGER: ICartAccessoryType;
  HEADPHONES: ICartAccessoryType;
  OTHER: ICartAccessoryType;
  POWER_BANK: ICartAccessoryType;
  PROTECTOR: ICartAccessoryType;
  SCREEN_PROTECTOR: ICartAccessoryType;
  SELFIE_STICK: ICartAccessoryType;
  TRIPOD: ICartAccessoryType;
  VIDEO_GAME_CONTROLLER: ICartAccessoryType;
  SMART_WATCH: ICartAccessoryType;
  DATA_BUNDLE: ICartAccessoryType;
} = {
  BASE_OR_SUPPORT: {
    name: "Base o Soporte",
    code: "BaseOSoporte",
  },
  BLUETOOTH_SPEAKER: {
    name: "Bocina Bluetooth",
    code: "BocinaBluetooth",
  },
  CABLE: {
    name: "Cable",
    code: "Cable",
  },
  CAMERA_ACCESSORY: {
    name: "Accesorio para Cámara",
    code: "AccesorioParaCámara",
  },
  CAR_CHARGER: {
    name: "Cargador de Auto",
    code: "CargadorDeAuto",
  },
  CAR_SUPPORT: {
    name: "Soporte para Auto",
    code: "SoporteParaAuto",
  },
  CHARGER: {
    name: "Cargador",
    code: "Cargador",
  },
  HEADPHONES: { name: "Audífonos", code: "Audífonos" },
  OTHER: {
    name: "Otro",
    code: "Otro",
  },
  POWER_BANK: {
    name: "Power Bank",
    code: "PowerBank",
  },
  PROTECTOR: {
    name: "Protector",
    code: "Protector",
  },
  SCREEN_PROTECTOR: {
    name: "Protector para pantalla",
    code: "ProtectorParaPantalla",
  },
  SELFIE_STICK: {
    name: "Selfie stick",
    code: "SelfieStick",
  },
  TRIPOD: {
    name: "Trípode",
    code: "Trípode",
  },
  VIDEO_GAME_CONTROLLER: {
    name: "Control para Videojuego",
    code: "ControlParaVideojuego",
  },
  SMART_WATCH: {
    name: "Smart Watch",
    code: "SmartWatch",
  },
  DATA_BUNDLE: {
    name: "Data Bundle",
    code: "DataBundle",
  },
};
